import { today } from '@squadcore/api/shared/time'
import { createFileRoute } from '@tanstack/react-router'
import { PlanPage } from '~/features/training/PlanPage'
import { planDate, planRange, type PlanSearch } from '~/features/training/search'
import { sessionsQuery } from '~/features/training/queries'
import { loaderScope } from '~/lib/session'

const isDate = (v: unknown): v is string => typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v)

export const Route = createFileRoute('/_app/training/')({
  validateSearch: (s: Record<string, unknown>): PlanSearch => ({
    ...(s.view === 'week' || s.view === 'month' ? { view: s.view } : {}),
    ...(isDate(s.date) ? { date: s.date } : {}),
  }),
  loaderDeps: ({ search }) => search,
  loader: async ({ context, deps }) => {
    const scope = await loaderScope(context.queryClient)
    if (!scope?.teamId) return
    const date = planDate(deps.date, scope.season, scope.seasonStartMonth, today(scope.timezone))
    const { from, to } = planRange(deps.view ?? 'month', date)
    // Errors show in the page (ErrorState with retry), not on the router's error screen.
    await context.queryClient.ensureQueryData(sessionsQuery(scope.teamId, scope.season, from, to)).catch(() => undefined)
  },
  component: function Plan() {
    return <PlanPage search={Route.useSearch()} />
  },
})
